import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, HashRouter, Route, Switch } from "react-router-dom";
import { ApolloProvider } from '@apollo/client';
import client from './lib/apollo-client';
import { AudioProvider } from './context/AudioContext';
import AudioPlayer from './components/audio-player/AudioPlayer';
import Navbar from './components/global-components/navbar';
import Footer from './components/global-components/footer';
import HomeV1 from './components/home-v1';
import HomeV2 from './components/home-v2';
import HomeV3 from './components/home-v3';
import CatPage from './components/cat-page';
import CatSports from './components/cat-sports';
import lifeStyle from './components/cat-life-style';
import Fashion from './components/cat-fashion';
import Author from './components/author';
import Error from './components/error';
import Blog from './components/blog';
import BlogDetails from './components/blog-details';
import CategoryPage from './components/category-page';
import SearchResults from './components/search-results';



class Root extends Component {
    render() {
        return(
                <ApolloProvider client={client}>
                    <AudioProvider>
                        <AudioPlayer />
                        <HashRouter basename="/">
                            <div style={{ paddingTop: '74px' }}>
                                <Navbar />
                                <Switch>
                                    <Route exact path="/" component={HomeV1} />
                                    <Route path="/home-v2" component={HomeV2} />
                                    <Route path="/home-v3" component={HomeV3} />
                                    <Route path="/cat-page" component={CatPage} />
                                    <Route path="/cat-sports" component={CatSports} />
                                    <Route path="/cat-life-style" component={lifeStyle} />
                                    <Route path="/cat-fashion" component={Fashion} />
                                    <Route path="/category/:slug" component={CategoryPage} />
                                    <Route path="/search" component={SearchResults} />
                                    <Route path="/author" component={Author} />
                                    <Route path="/error" component={Error} />
                                    <Route exact path="/blog" component={Blog} />
                                    <Route path="/blog/:slug" component={BlogDetails} />
                                </Switch>
                                <Footer />
                            </div>
                        </HashRouter>
                    </AudioProvider>
                </ApolloProvider>
        )
    }
}

export default Root;

ReactDOM.render(<Root />, document.getElementById('nextpage'));
